module.exports = __webpack_public_path__ + "img/logo-auto.cb6b40c9.png";